import React from "react";
import { FaShieldAlt } from "react-icons/fa";

const Privacy = () => {
  return (
    <div className="flex flex-col items-center z-10 xs:text-base md:text-xl bg-gradient-to-r from-white to-amber-50">
      <FaShieldAlt className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />

      <h1 className="text-red-600 font-extrabold text-4xl md:text-5xl tracking-wide">
          Privacy
        </h1>
     
      <div className="mt-5 flex flex-col w-2/3 items-center xs:text-base md:text-xl z-10">
        <p className="text-center text-red-600">Informativa sulla Privacy</p>
        <p className="text-center mt-5 text-red-600 underline">
          Ultimo aggiornamento: 19 gennaio 2024
        </p>
        <p className="text-center mt-5">
          Benvenuto su www.milarte.it. La tua privacy è importante per noi, e
          desideriamo che tu conosca come raccogliamo e utilizziamo le
          informazioni durante la tua visita al nostro sito.
        </p>
        <div className="mt-5 flex flex-col ">
          <p>
            1. Non raccogliamo informazioni personali identificabili senza il
            tuo consenso.
          </p>
          <p>
            2. Non raccogliamo dati per migliorare l'esperienza degli utenti,
            analizzare le tendenze di navigazione.
          </p>
          <p>
            3. Il nostro sito NON utilizza cookie per fini statistici e per
            migliorare la tua esperienza di navigazione.
          </p>
          <p>
            4. Non condividiamo intenzionalmente i dati con terze parti.
            Tuttavia, il nostro sito potrebbe includere link a siti esterni con
            politiche sulla privacy indipendenti.
          </p>
        </div>
        <p className="mt-7">
          Questa informativa può essere soggetta ad aggiornamenti. Verifica
          periodicamente per essere informato sulle modifiche.
        </p>
        <p className="mt-5">
          Per ulteriori informazioni o domande sulla nostra politica sulla
          privacy, contattaci all'indirizzo{" "}
          <a
            href="mailto: milarte.mi@gmail.com"
            className="text-red-600 underline"
          >
            milarte.mi@gmail.com
          </a>
        </p>
        <p className="mt-5 mb-5">
          Grazie per la tua fiducia nel visitare www.milarte.it.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
